import { Button } from "react-bootstrap";
import "./hr9-all-menu.scss";
import { useLocation, useNavigate } from "react-router-dom";

const HR9AllMenuComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const clickJDGen = () => {
        const queryParams = new URLSearchParams(location.search);

        // Navigate to "/xxx" with the updated query parameters
        navigate({
            pathname: '/hr9/jd-generator',
            search: queryParams.toString()
        });
    }

    const clickJDChecker = () => {
        const queryParams = new URLSearchParams(location.search);

        // Navigate to "/xxx" with the updated query parameters
        navigate({
            pathname: '/hr9/jd-checker',
            search: queryParams.toString()
        });
    }
    return (


        <>
            <div className="hr9-menu-main">
                <div className="hr9-menu-control">
                    <div className="hr9-menu-list">
                        <span className="hr9-menu-header">เลือกเมนูที่ต้องการให้ช่วยเหลือ</span>
                        <Button className="hr9-menu-button" onClick={clickJDGen}>JD Generator</Button>
                        <Button className="hr9-menu-button" onClick={clickJDChecker}>JD Checker</Button>
                        <Button className="hr9-menu-button">Resume Checker</Button>
                        <Button className="hr9-menu-button">Chat HR BOT</Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HR9AllMenuComponent;